import { useEffect } from 'react';
import { useClient } from '../context/ClientContext';
import { useCards } from '../context/CardContext';

/**
 * CardFetchSync Component
 * Automatically fetches cards when client logs in
 */
const CardFetchSync = () => {
  const { client, isAuthenticated } = useClient();
  const { fetchCards, clearCards } = useCards();

  useEffect(() => {
    if (isAuthenticated && client?.clientId && client?.tenantId) {
      fetchCards(client.clientId, client.tenantId);
    } else if (!isAuthenticated) {
      // Only clear cards when user explicitly logs out
      clearCards();
    }
  }, [isAuthenticated, client?.clientId, client?.tenantId, fetchCards, clearCards]);

  return null; // This component doesn't render anything
};

export default CardFetchSync;
